exports.components = {
  "component---node-modules-rohs-gatsby-theme-intro-src-pages-404-js": () => import("./../../../node_modules/@rohs/gatsby-theme-intro/src/pages/404.js" /* webpackChunkName: "component---node-modules-rohs-gatsby-theme-intro-src-pages-404-js" */),
  "component---node-modules-rohs-gatsby-theme-intro-src-templates-index-js": () => import("./../../../node_modules/@rohs/gatsby-theme-intro/src/templates/index.js" /* webpackChunkName: "component---node-modules-rohs-gatsby-theme-intro-src-templates-index-js" */)
}

